import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import api from '../utils/api';
import './AuthPage.css';

export default function RegisterPage() {
  const { login } = useAuth();

  const navigate = useNavigate();
  
  const [form, setForm] = useState({ username: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError('');

    if (form.password.length < 6) {
      setError('Пароль не менее 6 символов');

      return;
    }

    setBusy(true);

    try {
      const res = await api.post('/auth/register', form);

      login(res.data.token, res.data.user);

      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка регистрации');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className='auth-page'>
      <div className='auth-card'>
        <h1 className='auth-logo'>🏛️</h1>
        <p className='auth-subtitle'>GeoQuest</p>
        <h2>Регистрация</h2>
        <form onSubmit={handleSubmit}>
          <input
            className='auth-input'
            type='text'
            placeholder='Имя пользователя'
            value={form.username}
            onChange={e => setForm({ ...form, username: e.target.value })}
            required
          />
          <input
            className='auth-input'
            type='email'
            placeholder='Email'
            value={form.email}
            onChange={e => setForm({ ...form, email: e.target.value })}
            required
          />
          <input
            className='auth-input'
            type='password'
            placeholder='Пароль (не менее 6 символов)'
            value={form.password}
            onChange={e => setForm({ ...form, password: e.target.value })}
            required
          />
          {error && <p className='auth-error'>{error}</p>}
          <button className='auth-btn' type='submit' disabled={busy}>
            {busy ? 'Регистрируем…' : 'Зарегистрироваться'}
          </button>
        </form>
        <p className='auth-link'>
          Уже есть аккаунт? <Link to='/login'>Войти</Link>
        </p>
      </div>
    </div>
  );
}
